<!-- 考试 -->
<template>
    <div>
      <el-row class="course_examList">
        <ul>
          <template v-for="(item, index) in viewList">
            <li :key="index">
              <span class="num_examList">{{index + 1}}</span>
              <!-- 考试状态：未开始 / 进行中 / 已结束 -->
              <span class="status_examList" :class="'status_' + item.examStatus.key">{{item.examStatus.text}}</span>
              <el-row>
                <p class="title_examList limit_line_one">考试名称：{{item.teacherOpenCourseQuestionSettingName}}</p>
                <p class="number_examList"  style="color: #2789E2;">
                  <span>用时：{{item.finishTime || 0}}</span>
                  <span style="float: right;">正确率：{{item.questionLogSummarySuccessRate || 0}}%</span>

                </p>
              </el-row>
              <el-row class="m20">
                <p class="grade_examList">{{item.questionLogSummaryStudentTotalScore || '-'}}<span>分</span></p>
              </el-row>
              <el-row class="mb20">
                <el-col :span="16" class="font12">
                <p class="m0 pt5">题目数量：{{item.questionTotalCount || 0}}</p>
                <p class="m0 pt10">考试时间：{{item.teacherOpenCourseQuestionStartTime}}至{{item.teacherOpenCourseQuestionEndTime}}</p>
                </el-col>
                <el-col :span="4" class="tc">
                  <i class="el-icon-video-play font25" :class="item.canEnter ? 'c_p' : 'c_disable'" :style="{color: item.canEnter ? '#2789E2' : '#C0C4CC'}" @click="Exercises(item)"></i>
                  <br>
                  <el-link :class="item.canEnter ? '' : 'c_disable'" style="margin-top: 5px;font-size: 14px;" :underline="false" @click="Exercises(item)">开始考试</el-link>
                </el-col>
                <el-col :span="4" class="tc">
                  <i class="el-icon-document font25" :class="item.canViewScore ? 'c_p' : 'c_disable'" :style="{color: item.canViewScore ? '#FF6554' : '#C0C4CC'}" @click="achievement(item)"></i>
                  <br>
                  <el-link :class="item.canViewScore ? '' : 'c_disable'" style="margin-top: 5px;font-size: 14px;" :underline="false" @click="achievement(item)">成绩详情</el-link>
                </el-col>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
      <div v-if="viewList.length > 0"  class="block" style="text-align: right;bottom: 0;width: 96%;margin">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[9, 20, 50, 100]"
          :page-size="limit"
          background
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-empty v-if="viewList.length <= 0" description=""></el-empty>
    </div>
</template>
<script>

export default {
  name: 'ExamList',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {

      total: 0,
      limit:9,
      page:1,
      dataList: [],
      nowTick: Date.now(), //本机当前时间（配合 serverOffset 得到服务器时间）
      serverOffset: 0, //服务器时间 - 本机时间，避免学生电脑时钟不准导致状态判断和答题页不一致
      statusTimer: null, //定时刷新状态，让"未开始"到点自动变成"进行中"
    }
  },
  computed: {
    //校准后的当前时间
    currentTime() {
      return this.nowTick + this.serverOffset;
    },
    //列表数据 + 考试状态（未开始/进行中/已结束）
    viewList() {
      let now = this.currentTime;
      return (this.dataList || []).map((item) => {
        let startTime = this.toTimestamp(item.teacherOpenCourseQuestionStartTime);
        let endTime = this.toTimestamp(item.teacherOpenCourseQuestionEndTime);
        let examStatus = { key: 'ing', text: '进行中' };
        if(startTime && now < startTime){
          examStatus = { key: 'ready', text: '未开始' };
        }else if(endTime && now > endTime){
          examStatus = { key: 'ended', text: '已结束' };
        }
        return Object.assign({}, item, {
          examStatus: examStatus,
          canEnter: examStatus.key == 'ing',
          //是否已交卷：questionLogSummaryId 来自 left join question_log_summary（只有最终提交才有一行），
          //isFinished 是后端按这个 ID 算出来的，两者取或，兼容后端未返回 isFinished 的情况
          hasSubmitted: !this.$isEmpty(item.questionLogSummaryId) || item.isFinished === true,
          canViewScore: !this.$isEmpty(item.questionLogSummaryId) || item.isFinished === true
        });
      });
    }
  },
  created() {
    this.getServerTime();
    this.getInfo();
  },
  mounted() {
    this.statusTimer = setInterval(() => {
      this.nowTick = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if(this.statusTimer){
      clearInterval(this.statusTimer);
      this.statusTimer = null;
    }
  },
  methods: {
    toTimestamp(val){ //后端时间字符串转时间戳（"-"换"/"兼容各浏览器解析）
      if(this.$isEmpty(val)) return 0;
      let timestamp = Date.parse(String(val).trim().replace(/-/g, '/'));
      return isNaN(timestamp) ? 0 : timestamp;
    },
    getServerTime(){ //取服务器时间做校准，取不到就用本机时间
      this.$get("/api/base/dateTime.do").then((ret) =>{
        if(ret.code == 0 && ret.data && !this.$isEmpty(ret.data.dateTime)){
          let serverTime = this.toTimestamp(ret.data.dateTime);
          if(serverTime){
            this.serverOffset = serverTime - Date.now();
            this.nowTick = Date.now();
          }
        }
      }).catch(() => {});
    },
    formatTime(val){ //展示用：精确到分钟
      if(this.$isEmpty(val)) return '-';
      return String(val).trim().substring(0, 16);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取签到数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseQuestionSettingType: 'EXAM', // 考试
      }
      this.$post("/api/resourcesQuestionSnapshot/getQuestionTestSimpleInfo.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.dataList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    Exercises(item){ //开始答题
      //进入答题页前先按状态拦截，避免跳到答题页出现空白再弹"考试已结束"
      if(item.examStatus && item.examStatus.key == 'ready'){
        this.$message({
          message: '考试还未开始，开始时间：' + this.formatTime(item.teacherOpenCourseQuestionStartTime),
          type: 'warning'
        });
        return;
      }
      if(item.examStatus && item.examStatus.key == 'ended'){
        this.$message({
          message: '考试已结束（结束时间：' + this.formatTime(item.teacherOpenCourseQuestionEndTime) + '），可点击"成绩详情"查看成绩',
          type: 'warning'
        });
        return;
      }
      this.$ls.set(this.$getKeyInfo(item.teacherOpenCourseQuestionSettingId),{startTime:item.teacherOpenCourseQuestionStartTime,endTime:item.teacherOpenCourseQuestionEndTime});
      this.$router.push({name:'ExamListStart',query:{type:1,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,questionName:item.teacherOpenCourseQuestionSettingName}});
    },
    achievement(item){ //查看成绩
      //没交卷就没有成绩明细，别让进去看个空白页
      if(!item.canViewScore){
        let statusKey = item.examStatus ? item.examStatus.key : '';
        this.$message({
          message: statusKey == 'ready' ? '考试还未开始，暂无成绩详情'
            : statusKey == 'ing' ? '你还没有交卷，交卷后才能查看成绩详情'
            : '本次考试未参加或未交卷，没有成绩可查看',
          type: 'warning'
        });
        return;
      }
      this.$router.push({name:'ExamListDetails',query:{type:2,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    }
  }
};
</script>
<style  lang="less">
  .course_examList{
    ul{
      list-style-type:none;
      margin: 0;
      padding: 0;
    }
    li{
      float: left;
      width: calc(33.2% - 66px);
      margin: 0 20px 20px 0;
      min-height: 200px;
      border: 1px solid #E1E1E1;
      background-image: url("../../../images/course/kaoshi_bg@2x.png");
      background-size: 50px;
      background-repeat:no-repeat;
      position: relative;
      padding: 20px 20px 0;
      font-size: 14px;
      .num_examList{
        position: absolute;top: 10px;left: 10px;color: #2789E2;
      }
    }
    .title_examList{
      margin: 0;
      margin-left: 15px;
      width: calc(100% - 110px); /* 右侧给考试状态标签留位置 */
      line-height: 22px;
    }
    .number_examList{
      margin: 0;
      margin-top: 6px;
      line-height: 20px;
    }
    /* 考试状态标签：未开始 / 进行中 / 已结束 */
    .status_examList{
      position: absolute;
      top: 21px;
      right: 12px;
      height: 20px;
      line-height: 18px;
      padding: 0 8px;
      border-radius: 10px;
      border: 1px solid transparent;
      font-size: 12px;
      white-space: nowrap;
      &.status_ing{
        color: #FF6554;
        background-color: #FFF1EE;
        border-color: #FFD7CE;
      }
      &.status_ready{
        color: #2789E2;
        background-color: #EDF5FD;
        border-color: #CBE2F8;
      }
      &.status_ended{
        color: #8C939D;
        background-color: #F4F4F5;
        border-color: #E4E6E9;
      }
    }
    .c_disable{
      color: #C0C4CC !important;
      cursor: not-allowed !important;
    }
    .grade_examList{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .examList_img{
      width: 30px;
    }

    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/ExamList.vue